import React from "react"
import { useFormikContext, Field } from "formik"
import { Dropdown } from "primereact/dropdown"

import styles from "../../../../../styles/Form.module.css"

export default function DynamicDomain(props) {
  const formik = useFormikContext()

  const { field, index, mfFieldName, mfIndex } = props
  const fieldSlug = `${mfFieldName}.${mfIndex}.${field.field_name}`

  const isRequired = true

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={fieldSlug}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={({ value }) => {
                formik.setFieldValue(formikField.name, value)
                // Reset 'goal' Field
                const goalField = `${mfFieldName}.${mfIndex}.goal`
                formik.setFieldValue(goalField, "")
              }}
              options={field.field_options}
            />
            {meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
